import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    setChangedSubtitle,
    updateSubtitle
} from '@modules/subtitle';
import api from '@utils/axiosInstance';

function TextInput({ idx, text, el, setIsChanged }) {
    const changedTimelineSubtitle = useSelector(state => state.subtitle.changedTimelineSubtitle);
    const subtitleList = useSelector(state => state.subtitle.subtitleList);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const dispatch = useDispatch();
    const { uuid, lang } = useParams();

    const [changedObj, setChangedObj] = useState({});
    const [content, setContent] = useState('');

    useEffect(() => {
        if (changedTimelineSubtitle && el.id == changedTimelineSubtitle.id) {
            setContent(changedTimelineSubtitle.content);
        }
    }, [changedTimelineSubtitle]);

    useEffect(() => {
        if (subtitleList.length > 0) {
            setContent(subtitleList[idx]?.content);
        }
    }, [subtitleList, idx]);

    function handleChange(content) {
        const newObj = {
            ...subtitleList[idx],
            idx: idx,
            content: content
        };

        setChangedObj(newObj);

        dispatch(setChangedSubtitle({
            ...subtitleList[idx],
            idx: idx,
            content: content,
            type: 'text'
        }));

        setIsChanged(true);
    }

    function fetchText(e) {
        e.preventDefault();
        setIsChanged(false);

        if (Object.keys(changedObj).length > 0) {
            dispatch(updateSubtitle(idx, { content: changedObj.content }));

            // API 호출
            const tmpSubList = [...subtitleList];
            tmpSubList[idx] = {
                ...tmpSubList[idx],
                content: changedObj.content
            };

            saveSubtitlesToServer(tmpSubList);
        }
    }

    function saveSubtitlesToServer(subArr) {
        const formatted = subArr.map(list => ({
            identifier: String(list.id),
            start: list.start,
            end: list.end,
            text: list.content,
            styles: ""
        }));

        api({
            method: 'post',
            url: '/subtitle/aUpdate',
            data: {
                tk: userToken,
                uuid: uuid,
                ogc: organizationData.organization_code,
                lang: lang,
                subtitle: formatted
            }
        })
            .then((response) => {
                console.log('edit data', response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div key={idx} suppressContentEditableWarning={true} onBlur={e => fetchText(e)} >
            <div
                className='editable-text'
                contentEditable={true}
                suppressContentEditableWarning={true}
                placeholder="내용을 입력해주세요"
                onInput={(e) => handleChange(e.currentTarget.textContent)}
            >
                {content}
            </div>
        </div>
    );
}

export default TextInput;